import React, { useEffect, useState } from "react";
import { Form, Spinner } from "react-bootstrap";
import { useParams } from "react-router-dom";
import Multiselect from "multiselect-react-dropdown";
import { eiwrsUnblindingRequestManagementServices } from "../../../../APIServices/EIWRS/UnblindManagement/eiwrsUnblindingRequestManagementServices";
import { studySiteManagementServices } from "../../../../APIServices/CTMS/SiteManagement/studySiteManagementServices";
import { eiwrsUnblindingReasonServices } from "../../../../APIServices/EIWRS/UnblindManagement/eiwrsUnblindingReasonServices";
import { eiwrsUnblindingRequestTypeServices } from "../../../../APIServices/EIWRS/UnblindManagement/eiwrsUnblindingRequestTypeServices";
import { usersOnboardingService } from "../../../../APIServices/usersOnboarding";
import { studySubjectManagementServices } from "../../../../APIServices/CTMS/SubjectManagement/studySubjectManagementServices";

const AddNewStudyUnblindRequestManagement = ({ getEIWRSUnblindingRequestData, getEIWRSUnblindingRequestStats }) => {
  const [reasonList, setReasonList] = useState([]);
  const [siteList, setSiteList] = useState([]);
  const [subjectList, setSubjectList] = useState([]);
  const [requestTypeList, setRequestTypeList] = useState([]);
  const [userList, setUserList] = useState([]);
  const [siteId, setSiteId] = useState("");
  const [subjectId, setSubjectId] = useState("");
  const [reason, setReason] = useState("");
  const [requestType, setRequestType] = useState("");
  const [urgency, setUrgency] = useState("");
  const [medicalJustification, setMedicalJustification] = useState("");
  const [approver, setApprover] = useState("");
  const [buttonLoader, setButtonLoader] = useState(false);
  const [checkbox, setCheckbox] = useState(false);
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  let { studyId } = useParams();
  const LoginCat = JSON.parse(localStorage.getItem("role")).toLowerCase();

  const addNewEIWRSUnblindingRequest = async () => {
    setButtonLoader(true);
    let userData = {};
    userData.studyId = studyId;
    userData.siteId = siteId;
    userData.subjectId = subjectId;
    userData.requestType = requestType;
    userData.urgency = urgency;
    userData.reason = reason;
    userData.medicalJustification = medicalJustification;
    userData.approver = approver;
    userData.mode = StudyMode;
    let data = await eiwrsUnblindingRequestManagementServices.addNewEIWRSUnblindingRequest(
      userData
    );
    if (data?.statusCode === 200) {
      setSiteId("");
      setSubjectId("");
      setReason("");
      setRequestType("");
      setUrgency("");
      setMedicalJustification("");
      setApprover("");
      setCheckbox(false)
      getEIWRSUnblindingRequestData()
      getEIWRSUnblindingRequestStats()
    }
    setButtonLoader(false);
  };

  const getStudySiteBasedonAccess = async () => {
    let data = await studySiteManagementServices.getStudySiteBasedonAccess(studyId, LoginCat, StudyMode)
    setSiteList(data?.data || [])
  }

  const getStudySubjectRandomizationBySite = async () => {
    let data = await studySubjectManagementServices.getStudySubjectRandomizationBySite(studyId, siteId, StudyMode)
    setSubjectList(data?.data || [])
  }

  const getEIWRSUnblindingReasonData = async (e) => {
    let data = await eiwrsUnblindingReasonServices.getEIWRSUnblindingReasonData(
      "active",
      studyId,
    );
    setReasonList(data?.data || []);
  };

  const getEIWRSUnblindingRequestTypeData = async (e) => {
    let data = await eiwrsUnblindingRequestTypeServices.getEIWRSUnblindingRequestTypeData(
      "active",
      studyId,
    );
    setRequestTypeList(data?.data || []);
  };

  const getAssignedAppUser = async () => {
    let data = await usersOnboardingService.getAssignedAppUser(studyId, "eiwrs");
    setUserList(data?.data || []);
  };

  useEffect(() => {
    setSiteId("");
    setSubjectId("");
    setReason("");
    setRequestType("");
    setUrgency("");
    setMedicalJustification("");
    setApprover("");
    setCheckbox(false)
    getStudySiteBasedonAccess();
    getEIWRSUnblindingReasonData();
    getEIWRSUnblindingRequestTypeData();
    getAssignedAppUser()
  }, []);

  useEffect(() => {
    if (siteId) {
      getStudySubjectRandomizationBySite()
    }
  }, [siteId]);

  return (
    <div className="p-2">
      <Form.Group className="mb-1">
        <Form.Label className="fw-bold mb-1">
          Site Id <abbr title="Required" className="text-danger"> *</abbr>
        </Form.Label>
        <Form.Select
          value={siteId}
          disabled={siteList?.length === 0}
          onChange={(e) => setSiteId(e.target.value)}
          className="br3" style={{ fontSize: 12 }}>
          <option value="">Select Site</option>
          {siteList?.map((el, i) => (
            <option index={i} value={el?.siteId}>{el?.row?.SITEID}</option>
          ))}
        </Form.Select>
      </Form.Group>
      <Form.Group className="mb-1">
        <Form.Label className="fw-bold mb-1">
          Subject Id <abbr title="Required" className="text-danger"> *</abbr>
        </Form.Label>
        <Form.Select
          value={subjectId}
          disabled={subjectList?.length === 0}
          onChange={(e) => setSubjectId(e.target.value)}
          className="br3" style={{ fontSize: 12 }}>
          <option value="">Select Subject</option>
          {subjectList?.map((el, i) => (
            <option index={i} value={el?.subjectId}>{el?.row?.SUBJECTID}</option>
          ))}
        </Form.Select>
      </Form.Group>
      <Form.Group className="mb-1">
        <Form.Label className="fw-bold mb-1">
          Request Type <abbr title="Required" className="text-danger"> *</abbr>
        </Form.Label>
        <Form.Select
          value={requestType}
          disabled={requestTypeList?.length === 0}
          onChange={(e) => setRequestType(e.target.value)}
          className="br3" style={{ fontSize: 12 }}>
          <option value="">Select Request Type</option>
          {requestTypeList?.map((el, i) => (
            <option index={i} value={el?.requestType}>{el?.requestType}</option>
          ))}
        </Form.Select>
      </Form.Group>
      <Form.Group className="mb-1">
        <Form.Label className="fw-bold mb-1">
          Urgency <abbr title="Required" className="text-danger"> *</abbr>
        </Form.Label>
        <Form.Select
          value={urgency}
          onChange={(e) => setUrgency(e.target.value)}
          className="br3" style={{ fontSize: 12 }}>
          <option value="">Select Urgency</option>
          <option value="routine">Routine</option>
          <option value="urgent">Urgent</option>
          <option value="emergency">Emergency</option>
        </Form.Select>
      </Form.Group>
      <Form.Group className="mb-1">
        <Form.Label className="fw-bold mb-1">
          Reason <abbr title="Required" className="text-danger"> *</abbr>
        </Form.Label>
        <Form.Select
          value={reason}
          disabled={reasonList?.length === 0}
          onChange={(e) => setReason(e.target.value)}
          className="br3" style={{ fontSize: 12 }}>
          <option value="">Select Reason</option>
          {reasonList?.map((el, i) => (
            <option index={i} value={el?.reason}>{el?.reason}</option>
          ))}
        </Form.Select>
      </Form.Group>
      <Form.Group className="mb-1">
        <Form.Label className="fw-bold mb-1">
          Medical Justification{" "}
          <abbr title="Required" className="text-danger">
            *
          </abbr>
        </Form.Label>
        <Form.Control
          onChange={(e) => setMedicalJustification(e.target.value)}
          value={medicalJustification}
          className="br3"
          placeholder="Enter Medical Justification"
          as="textarea"
        />
      </Form.Group>
      <Form.Group className="mb-1">
        <Form.Label className="fw-bold mb-1">
          Route to Approver{" "}
          <abbr title="Required" className="text-danger">
            *
          </abbr>
        </Form.Label>

        <Form.Select
          value={approver}
          onChange={(e) => setApprover(e.target.value)}
        >
          <option value="">
            Select Approver
          </option>
          {userList?.map((item, index) => (
            <option key={index} value={item?.userId}>
              {item?.fullName}
            </option>
          ))}
        </Form.Select>
      </Form.Group>
      <Form.Group className="my-1">
        <Form.Label className="fw-bold mb-1">
          Electronic Signature{" "}
          <abbr title="Required" className="text-danger">
            *
          </abbr>
        </Form.Label>
        <Form.Check
          onChange={(e) => setCheckbox(e.target.checked)}
          checked={checkbox}
          className="br3"
          label="I confirm this request is justified."
          type="checkbox"
        />
      </Form.Group>
      <div className="text-end">
        <button
          disabled={!checkbox || !siteId || !subjectId || !requestType || !urgency || !reason || !medicalJustification || !approver || buttonLoader}
          onClick={addNewEIWRSUnblindingRequest}
          className="updateProfile"
        >
          {buttonLoader ? (
            <div className="hstack gap-2">
              <Spinner size="sm" /> Requesting...
            </div>
          ) : (
            "Request now"
          )}
        </button>
      </div>
    </div>
  );
};

export default AddNewStudyUnblindRequestManagement;
